module.exports = __webpack_public_path__ + "img/产品bg.aa2d187d.png";